module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mojito@2x_1fcc4b.jpg";